import { TOGGLE_MODAL, SET_DESIRED_PATH, SET_MODAL_MESSAGE } from '../actionTypes'

export default function modal(
  state = {
    modalOpen: false,
    desiredPath: null,
    message: null
  },
  action
) {
  switch (action.type) {
    case SET_DESIRED_PATH:
      return {
        ...state,
        desiredPath: action.path
      }
    case TOGGLE_MODAL:
      return {
        ...state,
        modalOpen: action.modalOpen
      }
    case SET_MODAL_MESSAGE:
      return {
        ...state,
        message: action.message
      }
    default:
      return state
  }
}
